import { createStore } from "vuex";
import api from "../api";

export default createStore({
  state: {
    allDiariesPath: null,
    loading: false,
    step: 0,
    bindingTypes: [],
    colourProfiles: [],
    styles: [],
    colourMap: {
      warm: ["Orange", "Pink", "Red", "Gold", "Yellow"],
      cool: ["Blue", "Green", "Purple"],
      neutral: ["Black", "White", "Brown", "Grey"]
    },
    results: [],
    sort: "favourite",
    lastQuery: null
  },
  getters: {
    encodedCollection() {
      return (collection, key) => {
        return collection
          .map(element => `${key}[]=${encodeURIComponent(element)}`)
          .join("&");
      };
    },
    stylesParams(state, getters) {
      return getters.encodedCollection(state.styles, "styles");
    },
    colourParams(state, getters) {
      return getters.encodedCollection(getters.colours, "colour");
    },
    categoryParams(state, getters) {
      return getters.encodedCollection(state.bindingTypes, "binding_type_vm");
    },
    colours(state) {
      return state.colourProfiles.flatMap(colour => state.colourMap[colour]);
    },
    resultsPath(state, getters) {
      return `/picks-for-you/results?${getters.joinedParams}&sort=${state.sort}`;
    },
    joinedParams(state, getters) {
      return [
        getters.categoryParams,
        getters.stylesParams,
        getters.colourParams
      ]
        .filter(Boolean)
        .join("&");
    }
  },
  actions: {
    async fetchResults({ state, commit, getters }) {
      if (state.lastQuery === getters.resultsPath) return;

      commit("setLastQuery", getters.resultsPath);
      commit("setLoading", true);
      const { data } = await api.get(getters.resultsPath);
      commit("setResults", data);
      commit("setLoading", false);
    },
    updateSort({ commit, dispatch }, sort) {
      commit("setSort", sort);
      dispatch("fetchResults");
    }
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setStep(state, step) {
      state.step = step;
    },
    toggleBindingType(state, value) {
      if (state.bindingTypes.includes(value)) {
        state.bindingTypes.splice(state.bindingTypes.indexOf(value), 1);
      } else {
        state.bindingTypes.push(value);
      }
    },
    toggleColourProfiles(state, value) {
      if (state.colourProfiles.includes(value)) {
        state.colourProfiles.splice(state.colourProfiles.indexOf(value), 1);
      } else {
        state.colourProfiles.push(value);
      }
    },
    toggleStyles(state, value) {
      if (state.styles.includes(value)) {
        state.styles.splice(state.styles.indexOf(value), 1);
      } else if (state.styles.length < 3) {
        state.styles.push(value);
      }
    },
    setResults(state, results) {
      state.results = results;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setAllDiariesPath(state, path) {
      state.allDiariesPath = path;
    },
    setLastQuery(state, query) {
      state.lastQuery = query;
    }
  }
});
